/**
 * Labels for a Maestro import snapshot.
 * Cut-off date and note are optional helpers typed at upload time.
 */

export function formatCutoffDate(value) {
  if (!value) return '';
  const raw = value instanceof Date
    ? `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(value.getDate()).padStart(2, '0')}`
    : String(value).slice(0, 10);
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(raw);
  if (!match) return '';
  const dt = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  if (Number.isNaN(dt.getTime())) return '';
  return dt.toLocaleDateString('en-CA', { year: 'numeric', month: 'short', day: 'numeric' });
}

export function formatMaestroBatchOption(batch, { isLatest = false, includeImporter = false } = {}) {
  const uploadedAt = batch?.imported_at ? new Date(batch.imported_at) : null;
  const uploadedOk = uploadedAt && !Number.isNaN(uploadedAt.getTime());
  const dateStr = uploadedOk
    ? uploadedAt.toLocaleDateString('en-CA', { year: 'numeric', month: 'short', day: 'numeric' })
    : '';
  const timeStr = uploadedOk
    ? uploadedAt.toLocaleTimeString('en-CA', { hour: '2-digit', minute: '2-digit' })
    : '';

  const parts = [];
  const cutoff = formatCutoffDate(batch?.cutoff_date);
  if (cutoff) parts.push(`Cut-off ${cutoff}`);
  if (dateStr) parts.push(`${dateStr} ${timeStr}`.trim());
  if (batch?.row_count != null) parts.push(`${batch.row_count} rows`);

  let text = parts.join(' · ') || 'Import';
  if (isLatest) text += ' (Latest)';

  const note = String(batch?.notes || '').trim();
  const legacyLabel = batch?.label && batch.label !== 'Initial import (migrated)'
    ? String(batch.label).trim()
    : '';
  const extra = note || legacyLabel;
  if (extra) {
    const short = extra.length > 60 ? `${extra.slice(0, 57)}…` : extra;
    text += ` — ${short}`;
  }
  if (includeImporter && batch?.imported_by_name) text += ` · ${batch.imported_by_name}`;
  return text;
}

/** Full cut-off and note, for the caption under the snapshot dropdown. */
export function maestroBatchCaption(batch) {
  if (!batch) return '';
  const cutoff = formatCutoffDate(batch.cutoff_date);
  const note = String(batch.notes || '').trim();
  const bits = [];
  if (cutoff) bits.push(`Cut-off ${cutoff}`);
  if (note) bits.push(note);
  return bits.join(' — ');
}
